import React from 'react';
import { DeckHistoryWrapper } from '@seedlang/hoc';
import DeckHistoryThumbnail from 'components/profile/deck_history_thumbnail';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import PlainPageHeading from 'components/plain_page_heading';
import Link from 'components/link';
import ProgressBar from 'components/progress_bar';
import Paginator from 'components/paginator';
import Spinner from 'components/spinner';
import Button from 'components/button/button';

const DeckRow = styled(Link)`
  display: flex;
  align-items: flex-start;
  padding: 15px 15px 15px 0;
  color: #333;
  background: transparent;
  transition: background-color 120ms ease;
  & + & {
    border-top: 1px solid #e5e5e5;
  }
  &:hover {
    background: #f7f7f7;
  }
`;

const RowContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const RowHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
`;

const DeckName = styled.div`
  font-weight: bold;
`;

const Date = styled.div`
  color: #777;
  font-size: 13px;
  margin-top: 4px;
`;

const Status = styled.div`
  color: ${props => props.finished ? Theme.green : '#777'};
  font-weight: bold;
  font-size: 13px;
`;

const ProgressDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #777;
`;

const ProgressBarWrapper = styled.div`
  flex: 1;
`;

@observer
class LatestDecks extends React.Component {
  render() {
    return (
      <>
        <PlainPageHeading contentGap={15}>Deck History</PlainPageHeading>
        {this.props.loadFailed ? (
          <>
            <p>Sorry, we couldn&apos;t load your latest decks.</p>
            <Button onClick={this.props.onReload}>Try Again</Button>
          </>
        ) : (
          <>
            {this.props.loading && <Spinner />}
            {this.props.showEmpty && <p>You have no recent decks.</p>}
            {this.props.rows.map(({ userDeck, name, total, current, showProgress }) => {
              return (
                <DeckRow
                  key={userDeck.id}
                  to={{ name: 'decks.show', params: { deckId: userDeck.deckId } }}
                >
                  <DeckHistoryThumbnail deck={userDeck.deck} />
                  <RowContent>
                    <RowHeader showProgress={showProgress}>
                      <div>
                        <DeckName>{name}</DeckName>
                        <Date>{userDeck.updatedAt?.formattedDateWithYearAndTime || ''}</Date>
                      </div>
                      {showProgress && (
                        <Status finished={userDeck.finished}>
                          {userDeck.finished ? 'Finished' : 'In progress'}
                        </Status>
                      )}
                    </RowHeader>
                    {showProgress && (
                      <ProgressDetails>
                        <ProgressBarWrapper>
                          <ProgressBar
                            background='#e8e8e8'
                            borderRadius='5px'
                            current={current}
                            height='8px'
                            total={total}
                          />
                        </ProgressBarWrapper>
                        <span>{current} of {total}</span>
                      </ProgressDetails>
                    )}
                  </RowContent>
                </DeckRow>
              );
            })}
            {this.props.showPaginator && (
              <Paginator
                store={this.props.store}
                queryStrings={{ user_id: this.props.userId }}
                onClickScrollToTop
                withSpinner
              />
            )}
          </>
        )}
      </>
    );
  }
}

export default DeckHistoryWrapper(LatestDecks);
